module.exports = __webpack_public_path__ + "img/vet.f37a730a.svg";